import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import { Row, Col } from 'reactstrap';
import ModalPopup from 'components/organisms/modal';
import Button from 'components/atoms/button';
import Input from 'components/atoms/input';
import { showResult, getInitialValues } from 'utils';
import * as Yup from 'yup';
import common from 'constants/common';

const MEDICAL_HISTORY_FIELDS = [
  { id: 'issue', type: 'text', label: 'Medical Issue' },
  { id: 'surgeryHist', type: 'text', label: 'Surgery History' },
  { id: 'hospitalizationHist', type: 'text', label: 'Hospitalization History' },
];
const MedicalHistorySchema = Yup.object().shape({
  issue: Yup.string().nullable(),
  surgeryHist: Yup.string().nullable(),
  hospitalizationHist: Yup.string().nullable(),
});
const EditMedicalHistoryModal = ({
  isOpen,
  toggle,
  patientGuid,
  loading,
  medicalHistory,
  submit,
}) => {
  const handleSubmit = async (values) => {
    const postData = {
      guid: medicalHistory.guid,
      patientGuid,
      ...values,
    };
    const { error } = await submit(postData);
    showResult(error, common.submitSuccessTypes.changed, toggle);
  };

  const disableSaveButton = (values) =>
    !Object.values(values).some(
      (value) => value?.trim() !== '' && value !== null && value !== undefined,
    );

  return (
    <ModalPopup
      isOpen={isOpen}
      toggle={toggle}
      title="Edit Medical History"
      className="popup edit-medical-history-popup"
    >
      <Formik
        initialValues={getInitialValues(MEDICAL_HISTORY_FIELDS, medicalHistory)}
        onSubmit={handleSubmit}
        validationSchema={MedicalHistorySchema}
      >
        {({ errors, values }) => (
          <Form className="user--form edit-medical-history">
            <Row>
              {MEDICAL_HISTORY_FIELDS.map((field, index) => (
                <Col key={index} lg="4" md="4" sm="6" xs="12">
                  <Input {...field} />
                  {errors[field.id] ? (
                    <div className="input-error">{errors[field.id]}</div>
                  ) : null}
                </Col>
              ))}
            </Row>
            {disableSaveButton(values) && <p>at least one field required*</p>}

            <div className="text-center">
              <Button
                type="submit"
                text="Save"
                disabled={loading || disableSaveButton(values)}
              />
            </div>
          </Form>
        )}
      </Formik>
    </ModalPopup>
  );
};
EditMedicalHistoryModal.defaultProps = {
  isOpen: false,
};

EditMedicalHistoryModal.propTypes = {
  toggle: PropTypes.func.isRequired,
  patientGuid: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  loading: PropTypes.bool.isRequired,
  submit: PropTypes.func.isRequired,
  medicalHistory: PropTypes.shape().isRequired,
};

export default EditMedicalHistoryModal;
